/* tslint:disable */
/* eslint-disable */
/**
 * BonusX
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { DocumentToSignStatus } from '../models';
// @ts-ignore
import type { InputReviewDocumentToSign } from '../models';
// @ts-ignore
import type { ServiceRequestDocumentToSign } from '../models';
/**
 * AdminSignatureApi - axios parameter creator
 * @export
 */
export const AdminSignatureApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *  **Permission required**: [\"readAll\", \"ServiceRequestDocumentToSign\"] 
         * @summary Get requested services
         * @param {number} id 
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allServiceRequestDocumentToSign: async (id: number, filter?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('allServiceRequestDocumentToSign', 'id', id)
            const localVarPath = `/admin/signature/by-service-request/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"update\", \"ServiceRequest\"] 
         * @summary Create a document to sign
         * @param {number} [serviceRequestId] 
         * @param {number} [category] 
         * @param {Array<File>} [files] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocumentToSign: async (serviceRequestId?: number, category?: number, files?: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/signature/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (serviceRequestId !== undefined) { 
                localVarFormParams.append('serviceRequestId', serviceRequestId as any);
            }
    
            if (category !== undefined) { 
                localVarFormParams.append('category', category as any);
            }
                if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"delete\", \"ServiceRequestDocumentToSign\"] 
         * @summary Delete documento to sign or signed. | Permission required: [\"delete\", \"ServiceRequestDocumentToSign\"]
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentToSign: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteDocumentToSign', 'id', id)
            const localVarPath = `/admin/signature/by-service-request/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"update\", \"ServiceDocumentStatus\"] 
         * @summary review a signature document uploaded by a user | Permission required: [\"update\", \"ServiceDocumentStatus\"]
         * @param {InputReviewDocumentToSign} [inputReviewDocumentToSign] body for reviewing a document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewSignature: async (inputReviewDocumentToSign?: InputReviewDocumentToSign, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/signature/caf-review`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputReviewDocumentToSign, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminSignatureApi - functional programming interface
 * @export
 */
export const AdminSignatureApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminSignatureApiAxiosParamCreator(configuration)
    return {
        /**
         *  **Permission required**: [\"readAll\", \"ServiceRequestDocumentToSign\"] 
         * @summary Get requested services
         * @param {number} id 
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allServiceRequestDocumentToSign(id: number, filter?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServiceRequestDocumentToSign>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allServiceRequestDocumentToSign(id, filter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSignatureApi.allServiceRequestDocumentToSign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"update\", \"ServiceRequest\"] 
         * @summary Create a document to sign
         * @param {number} [serviceRequestId] 
         * @param {number} [category] 
         * @param {Array<File>} [files] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDocumentToSign(serviceRequestId?: number, category?: number, files?: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceRequestDocumentToSign>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDocumentToSign(serviceRequestId, category, files, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSignatureApi.createDocumentToSign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"delete\", \"ServiceRequestDocumentToSign\"] 
         * @summary Delete documento to sign or signed. | Permission required: [\"delete\", \"ServiceRequestDocumentToSign\"]
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDocumentToSign(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDocumentToSign(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSignatureApi.deleteDocumentToSign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"update\", \"ServiceDocumentStatus\"] 
         * @summary review a signature document uploaded by a user | Permission required: [\"update\", \"ServiceDocumentStatus\"]
         * @param {InputReviewDocumentToSign} [inputReviewDocumentToSign] body for reviewing a document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reviewSignature(inputReviewDocumentToSign?: InputReviewDocumentToSign, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentToSignStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reviewSignature(inputReviewDocumentToSign, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSignatureApi.reviewSignature']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminSignatureApi - factory interface
 * @export
 */
export const AdminSignatureApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminSignatureApiFp(configuration)
    return {
        /**
         *  **Permission required**: [\"readAll\", \"ServiceRequestDocumentToSign\"] 
         * @summary Get requested services
         * @param {number} id 
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allServiceRequestDocumentToSign(id: number, filter?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServiceRequestDocumentToSign>> {
            return localVarFp.allServiceRequestDocumentToSign(id, filter, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"update\", \"ServiceRequest\"] 
         * @summary Create a document to sign
         * @param {number} [serviceRequestId] 
         * @param {number} [category] 
         * @param {Array<File>} [files] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocumentToSign(serviceRequestId?: number, category?: number, files?: Array<File>, options?: RawAxiosRequestConfig): AxiosPromise<ServiceRequestDocumentToSign> {
            return localVarFp.createDocumentToSign(serviceRequestId, category, files, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"delete\", \"ServiceRequestDocumentToSign\"] 
         * @summary Delete documento to sign or signed. | Permission required: [\"delete\", \"ServiceRequestDocumentToSign\"]
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentToSign(id: number, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteDocumentToSign(id, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"update\", \"ServiceDocumentStatus\"] 
         * @summary review a signature document uploaded by a user | Permission required: [\"update\", \"ServiceDocumentStatus\"]
         * @param {InputReviewDocumentToSign} [inputReviewDocumentToSign] body for reviewing a document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewSignature(inputReviewDocumentToSign?: InputReviewDocumentToSign, options?: RawAxiosRequestConfig): AxiosPromise<DocumentToSignStatus> {
            return localVarFp.reviewSignature(inputReviewDocumentToSign, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminSignatureApi - interface
 * @export
 * @interface AdminSignatureApi
 */
export interface AdminSignatureApiInterface {
    /**
     *  **Permission required**: [\"readAll\", \"ServiceRequestDocumentToSign\"] 
     * @summary Get requested services
     * @param {number} id 
     * @param {string} [filter] page, perPage, order, orderBy, filter (object)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSignatureApiInterface
     */
    allServiceRequestDocumentToSign(id: number, filter?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServiceRequestDocumentToSign>>;

    /**
     *  **Permission required**: [\"update\", \"ServiceRequest\"] 
     * @summary Create a document to sign
     * @param {number} [serviceRequestId] 
     * @param {number} [category] 
     * @param {Array<File>} [files] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSignatureApiInterface
     */
    createDocumentToSign(serviceRequestId?: number, category?: number, files?: Array<File>, options?: RawAxiosRequestConfig): AxiosPromise<ServiceRequestDocumentToSign>;

    /**
     *  **Permission required**: [\"delete\", \"ServiceRequestDocumentToSign\"] 
     * @summary Delete documento to sign or signed. | Permission required: [\"delete\", \"ServiceRequestDocumentToSign\"]
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSignatureApiInterface
     */
    deleteDocumentToSign(id: number, options?: RawAxiosRequestConfig): AxiosPromise<any>;

    /**
     *  **Permission required**: [\"update\", \"ServiceDocumentStatus\"] 
     * @summary review a signature document uploaded by a user | Permission required: [\"update\", \"ServiceDocumentStatus\"]
     * @param {InputReviewDocumentToSign} [inputReviewDocumentToSign] body for reviewing a document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSignatureApiInterface
     */
    reviewSignature(inputReviewDocumentToSign?: InputReviewDocumentToSign, options?: RawAxiosRequestConfig): AxiosPromise<DocumentToSignStatus>;

}

/**
 * AdminSignatureApi - object-oriented interface
 * @export
 * @class AdminSignatureApi
 * @extends {BaseAPI}
 */
export class AdminSignatureApi extends BaseAPI implements AdminSignatureApiInterface {
    /**
     *  **Permission required**: [\"readAll\", \"ServiceRequestDocumentToSign\"] 
     * @summary Get requested services
     * @param {number} id 
     * @param {string} [filter] page, perPage, order, orderBy, filter (object)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSignatureApi
     */
    public allServiceRequestDocumentToSign(id: number, filter?: string, options?: RawAxiosRequestConfig) {
        return AdminSignatureApiFp(this.configuration).allServiceRequestDocumentToSign(id, filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"update\", \"ServiceRequest\"] 
     * @summary Create a document to sign
     * @param {number} [serviceRequestId] 
     * @param {number} [category] 
     * @param {Array<File>} [files] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSignatureApi
     */
    public createDocumentToSign(serviceRequestId?: number, category?: number, files?: Array<File>, options?: RawAxiosRequestConfig) {
        return AdminSignatureApiFp(this.configuration).createDocumentToSign(serviceRequestId, category, files, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"delete\", \"ServiceRequestDocumentToSign\"] 
     * @summary Delete documento to sign or signed. | Permission required: [\"delete\", \"ServiceRequestDocumentToSign\"]
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSignatureApi
     */
    public deleteDocumentToSign(id: number, options?: RawAxiosRequestConfig) {
        return AdminSignatureApiFp(this.configuration).deleteDocumentToSign(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"update\", \"ServiceDocumentStatus\"] 
     * @summary review a signature document uploaded by a user | Permission required: [\"update\", \"ServiceDocumentStatus\"]
     * @param {InputReviewDocumentToSign} [inputReviewDocumentToSign] body for reviewing a document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSignatureApi
     */
    public reviewSignature(inputReviewDocumentToSign?: InputReviewDocumentToSign, options?: RawAxiosRequestConfig) {
        return AdminSignatureApiFp(this.configuration).reviewSignature(inputReviewDocumentToSign, options).then((request) => request(this.axios, this.basePath));
    }
}

